import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");

var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");

var ReadingLevelTable = require("components/reading/reading_levels/ReadingLevelTable");

var Spinner = require("components/utility/Spinner");
var PaginationControls = require("components/utility/PaginationControls");

var RosterActions = require("lib/actions/RosterActions");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

function propsToConditions(props) {
	var conditions = {userIDs: paginateUserIds(props)};
	conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	return conditions;
}

function paginateUserIds(props) {
	var page = (props.page || 1)
	var perPage = (props.perPage || DataRouting.PER_PAGE)
	return props.userIDs.slice(perPage * (page  - 1), page * perPage)
}

@connect(
	(state, props) => {

		var downProps = {}
		

		downProps.userIDs = paginateUserIds(props)
		downProps.loading = ReadingSelectors.isLoadingReadingLevels({ state })
		downProps.readingLevels = ReadingSelectors.readingLevels({
			state,
			conditions: propsToConditions(props)
		})
		downProps.assessmentDates = ReadingSelectors.assessmentDates({
			state,
			conditions: propsToConditions(props),
			sinceSchoolYear: true, untilPresent: true
		})
		downProps.totalStudentCount = props.userIDs.length

		return downProps;
	},
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
		      if ($wr.isLargeRequest(props.userIDs)) {
			var actionFunction = ReadingActions.fetchReadingLevels
			var options = { cache: true }
			return new Promise(function (resolve, reject) {
				// reading level
				$wr.handleLargeRequest(dispatch, props.userIDs, {}, actionFunction, options, function (results) {
					var readingLevelPromise = results
					actionFunction = RosterActions.fetchStudents
					options.embeds = ["student.cloze_status", "student.current_reading_level_origin"]
					options.page = props.page || 1
					// students
					$wr.handleLargeRequest(dispatch, props.userIDs, {}, actionFunction, options, function (second_results) {
						var studentsPromise = second_results
						resolve(_.compact(_.flatten(readingLevelPromise.concat(studentsPromise))));
					})
				})
			}).catch(() => console.log("Reading levels and students failed to load"));
		      } else {
			var readingLevelPromise = dispatch(ReadingActions.fetchReadingLevels({
			  conditions: propsToConditions(props),
			  cache: true
			}));

			var studentsPromise = dispatch(RosterActions.fetchStudents({
			  conditions: propsToConditions(props),
			  embeds: ["student.cloze_status", "student.current_reading_level_origin"],
			  page: (props.page || 1),
			  cache: true
			}))

			return Promise.all([readingLevelPromise, studentsPromise]);
		      }
		    }
		})
)
@providePopulateData({ waitForLoad: true })
class DataReadingLevels extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	render() {
		var display = "Display here";
		if (this.props.loading) {
			var display = <Spinner placeholder scale={ 1.7 } />
		} else {
			var display = (
				<ReadingLevelTable userIDs={ this.props.userIDs }
					dates={ this.props.assessmentDates }
					readingLevels={ this.props.readingLevels } />
			);
		}
		if (this.props.onPageChange && this.props.totalStudentCount) {
			if (this.props.showFullData) {
				var pagination = (
					<PaginationControls page={ this.props.page || 1 }
						perPage={ this.props.perPage || DataRouting.PER_PAGE }
						perPageOptions={ PaginationControls.DEFAULT_PAGE_OPTIONS }
						totalCount={ this.props.totalStudentCount }
						onPageChange={ this.props.onPageChange } />
				);
			}	
		}
		return (
			<div className="dataReadingLevels">
				{ pagination }
				{ display }
			</div>
		)
	}
}
DataReadingLevels.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	showFullData: PropTypes.bool,
	onPageChange: PropTypes.func,
	page: PropTypes.number,
	perPage: PropTypes.number,
	order: PropTypes.string,
	totalStudentCount: PropTypes.number,

	// Data from @connect
	loading: PropTypes.bool,
	readingLevels: PropTypes.array,
	assessmentDates: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataReadingLevels;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataReadingLevels.js